<template>
  <main>
    <BannerBlock />
    <ParticipationBlock />
    <MembersBlock />
    <JuryBlock :separatePage="false" v-bind="messages.index.jury" />
  </main>
</template>

<script>
import { Head } from '~/mixins/Head'
import { PageMixin } from '~/mixins/PageMixin'
import BannerBlock from '~/components/BannerBlock'
import ParticipationBlock from '~/components/ParticipationBlock'
import MembersBlock from '~/components/MembersBlock'
import JuryBlock from '~/components/JuryBlock'

export default {
  name: 'index',
  mixins: [PageMixin, Head],
  components: {
    BannerBlock,
    ParticipationBlock,
    MembersBlock,
    JuryBlock
  },
  computed: {
    metaObj() {
      return this.messages.index.meta
    }
  }
}
</script>



// WEBPACK FOOTER //
// pages/index.vue